import React from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Col,
  FormControl,
  Row,
  Table
} from 'react-bootstrap';
import moment from 'moment'
import { FormattedMessage, injectIntl } from 'react-intl';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from '../../../locale/messages';
import cx from 'classnames';

// Components

import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';
import CurrencyConverter from '../../CurrencyConverter/CurrencyConverter';
import CustomPagination from '../../CustomPagination/CustomPagination';
import manualPayout from '../../../actions/siteadmin/WeeklyPayout/manualPayout';

import bt from '../../../components/commonStyle.css';
import s from './PayoutManagement.css';
import DateRange from './DateRange/DateRange';
import { formValueSelector, reduxForm } from 'redux-form';
import { openDateFilterModal } from '../../../actions/siteadmin/modalActions';
import DateFilterModal from '../DateFilterModal/DateFilterModal';

class PayoutManagement extends React.Component {
  static defaultProps = {
    weeklyPayoutData: []
  };

  constructor(props) {
    super(props);
    this.scrollableDivRef = React.createRef();
    this.state = {
      currentPage: 1,
      isLoading: false,
      showSection: 0,
      isOpen: false
    }
    this.handlePending = this.handlePending.bind(this);
    this.handleCompleted = this.handleCompleted.bind(this);
  }

  handlePayout = async (value, id) => {
    const { manualPayout, weeklyPayoutData: { refetch } } = this.props;
    const { currentPage } = this.state;
    let variables = {
      id,
      isPayoutStatus: value
    }
    if (value == 'true') {
      const response = await manualPayout(variables);
      if (response.status == 200) {
        // refetch({
        //   currentPage: 1,
        //   payoutStatus: false
        // })
      }
    }
    refetch({
      currentPage,
      payoutStatus: false
    })
  }


  async handlePending() {
    const { weeklyPayoutData: { refetch } } = this.props
    this.setState({
      currentPage: 1,
      showSection: 0
    });
    let variables = {
      currentPage: 1,
      payoutStatus: false
    }
    refetch(variables)
  }

  async handleCompleted() {
    const { weeklyPayoutData: { refetch } } = this.props
    this.setState({
      currentPage: 1,
      showSection: 1
    });
    let variables = {
      currentPage: 1,
      payoutStatus: true
    }
    refetch(variables)
  }

  handleKeywordSearch = (searchList) => {
    const { weeklyPayoutData: { refetch } } = this.props
    let variables = {
      currentPage: 1,
      searchList
    }
    refetch(variables)
  }

  handleDateFilter = (value) => {
    const { weeklyPayoutData: { refetch }, dates } = this.props;
    const { isOpen, datesFilter } = this.state;
    let variables = {
      currentPage: 1,
      dates
    }
    this.setState({ isOpen: !isOpen, datesFilter: true })
    refetch(variables)

  }

  paginationData = (currentPage) => {
    const { weeklyPayoutData: { refetch } } = this.props;
    let variables = { currentPage };
    this.setState({ currentPage, isLoading: true });
    if (this.scrollableDivRef.current) {
      this.scrollableDivRef.current.scrollTop = 0;
    }
    refetch(variables)
  }


  render() {
    const { weeklyPayoutData, weeklyPayoutData: { getAllWeeklyPayout }, dates, openDateFilterModal } = this.props;
    const { showSection } = this.state;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.widthInner, 'whiteDropdown', 'bgBlackTwo')}>
        <div className={s.tabContainerFlex}>
          <Button className={cx(bt.btnPrimary, { [bt.btnSecondary]: showSection === 1 }, { ['darkModeTabSecondary']: showSection === 1 })} onClick={() => this.handlePending()} ><FormattedMessage {...messages.pending} /></Button>
          <Button className={cx(bt.btnPrimary, { [bt.btnSecondary]: showSection === 0 }, { ['darkModeTabSecondary']: showSection === 0 })} onClick={() => this.handleCompleted()}><FormattedMessage {...messages.completed} /></Button>
        </div>
        <div className={s.searchFilterFlex}>
          <FormControl className={cx(bt.formControlInput, 'tableSearchFilterInput')} type='text' placeholder={formatMessage(messages.searchOnly)} onChange={(e) => this.handleKeywordSearch(e.target && e.target.value)} />
          <Button className={bt.btnPrimary} onClick={() => openDateFilterModal()}>
            <FormattedMessage {...messages.filterByDateLabel} />
          </Button>
          {this.state.isOpen && <DateRange numberOfMonths={1} />}
        </div>

        <DateFilterModal weeklyPayoutData={weeklyPayoutData} dates={dates} />




        {
          <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewResponsiveTable', 'topScrollbarTable')} ref={this.scrollableDivRef}>
            <Table className={cx("table", 'topScrollbarTableContent')}>
              <thead>
                <tr>
                  <th scope="col"><FormattedMessage {...messages.sNoLabel} /></th>
                  <th scope="col"><FormattedMessage {...messages.driverName} /></th>
                  <th scope="col"><FormattedMessage {...messages.email} /></th>
                  <th scope="col"><FormattedMessage {...messages.weekRangeLabel} /></th>
                  <th scope="col"><FormattedMessage {...messages.payoutAmount} /></th>
                  <th scope="col"><FormattedMessage {...messages.payoutStatus} /></th>
                </tr>
              </thead>
              <tbody>
                {
                  getAllWeeklyPayout && getAllWeeklyPayout.results && getAllWeeklyPayout.results.length > 0 && getAllWeeklyPayout.results.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td data-label={formatMessage(messages.sNoLabel)}>{index + 1 + ((this.state.currentPage - 1) * 10)}</td>
                        <td data-label={formatMessage(messages.driverName)}>{item && item.driverDetails && capitalizeFirstLetter(item.driverDetails.firstName)}</td>
                        <td data-label={formatMessage(messages.email)}>{item && item.driverDetails && item.driverDetails.userData && item.driverDetails.userData.email}</td>
                        <td data-label={formatMessage(messages.weekRangeLabel)}>{moment(item.weekStartDate).format('MMMM DD YYYY') + " to " + moment(item?.weekEndDate).format('MMMM DD YYYY')} </td>
                        <td data-label={formatMessage(messages.payoutAmount)}><CurrencyConverter amount={item.amount} /></td>
                        <td data-label={formatMessage(messages.payoutStatus)}>{item.isPayoutStatus ? formatMessage(messages.completed) :
                          <select name="isPayoutStatus" value={item?.isPayoutStatus} className={bt.selectInput} onChange={(e) => this.handlePayout(e.target.value, item?.id)}>
                            <option value={false}>{formatMessage(messages.pending)}</option>
                            <option value={true}>{formatMessage(messages.completed)}</option>
                          </select>}</td>
                      </tr>
                    )
                  })
                }
                {
                  getAllWeeklyPayout && getAllWeeklyPayout.results && getAllWeeklyPayout.results.length == 0 && (
                    <tr className='tableNodataText'>
                      <td colSpan="12"><FormattedMessage {...messages.noResult} /></td>
                    </tr>
                  )
                }
              </tbody>
            </Table>
          </div>
        }

        {
          getAllWeeklyPayout && getAllWeeklyPayout.count > 0 && (
            <div>
              <CustomPagination
                total={getAllWeeklyPayout.count}
                currentPage={this.state.currentPage || 1}
                defaultCurrent={1}
                defaultPageSize={10}
                change={this.paginationData}
                paginationLabel={formatMessage(messages.payoutManagementLabel)}
              />
            </div>
          )
        }

      </div>
    );
  }
}

PayoutManagement = reduxForm({
  form: "PayoutManagement", // a unique name for this form
  // destroyOnUnmount: false
})(PayoutManagement);

const selector = formValueSelector('PayoutManagement');

const mapState = (state) => ({
  loading: state.intl.loading,
  dates: selector(state, 'dates')
});
const mapDispatch = {
  manualPayout,
  openDateFilterModal
};
export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(PayoutManagement)));